"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGameData = useGameData;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _context = require("../context");

function useGameData(_ref) {
  var sheet = _ref.sheet,
      columns = _ref.columns,
      id = _ref.id,
      language = _ref.language;

  var _useContext = (0, _react.useContext)(_context.Context),
      defaultLanguage = _useContext.defaultLanguage,
      getCachedData = _useContext.getCachedData,
      requestGameData = _useContext.requestGameData;

  var resolvedLanguage = language !== null && language !== void 0 ? language : defaultLanguage; // Initialise the state from the cache, if there's anything there

  var _useState = (0, _react.useState)(function () {
    return getCachedData([columns, resolvedLanguage, sheet, id]);
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1]; // Send out a request for updated data. This will hit cache if it's already available.


  (0, _react.useEffect)(function () {
    requestGameData([columns, resolvedLanguage, sheet, id]).then(function (data) {
      return setData(data);
    });
  }, [requestGameData, sheet, columns, id, resolvedLanguage]);
  return data;
}